import { FormikProps } from 'formik';
import { FC, useState } from 'react';
import { clsx } from 'clsx';
import FormError from 'components/Forms/FormError/FormError';
import { ITavusPersonaFormik } from 'entities/tavus/persona';
import { replicaStore } from 'entities/tavus/replica/model/replicaStore';
import { AvatarListModal } from 'features/avatar-list-modal';
import { voiceStore } from 'entities/tavus/voice';
import { VoiceSelectButton } from './VoiceSelectButton';
import { VoiceModal } from 'features/voice-modal';
import SelectInput from 'components/shared/SelectInput';
import { LANGUAGES } from 'shared/model';
import { cn } from 'shared/lib';

interface IProps {
  formik: FormikProps<ITavusPersonaFormik>;
}

export const AvatarIdentityForm: FC<IProps> = ({ formik }) => {
  const [openAvatarListModal, setOpenAvatarListModal] = useState(false);
  const [openVoiceModal, setOpenVoiceModal] = useState(false);
  const { voices } = voiceStore();
  const currentVoice = voices?.find(
    (item) => item.providerId === formik.values.voiceId
  );
  return (
    <div className="ag-h-full ag-overflow-y-auto ag-flex ag-flex-col ag-gap-y-4">
      <div className="ag-flex ag-flex-col ag-relative ag-gap-y-2">
        <label
          className="ag-text-sm ag-flex ag-flex-col ag-gap-y-1"
          htmlFor="name"
        >
          <div className="ag-font-semibold ag-text-neutral-900">Name</div>
          <div className="ag-text-gray-muted">
            What’s the name of your Video Agent?
          </div>
        </label>

        <input
          className={clsx(
            'ag-border ag-text-neutral-900 ag-border-neutral-300 ag-py-2 ag-px-3 ag-rounded-md ag-text-sm ag-outline-none ag-ring-0 focus:ag-outline-none focus:ag-ring-0 ag-bg-neutral-50',
            formik.errors.name && formik.touched.name
              ? 'ag-text-red-900  focus:ag-border-red-500'
              : 'placeholder:ag-text-neutral-500 focus:ag-border-primary-800'
          )}
          placeholder="My Video Agent"
          onBlur={formik.handleBlur}
          onChange={formik.handleChange}
          value={formik.values.name}
          name="name"
          id="name"
        />
        {formik.errors.name && formik.touched.name && (
          <FormError>{formik.errors.name}</FormError>
        )}
      </div>
      <div className="ag-flex ag-flex-col ag-gap-y-2">
        <label
          className="ag-text-sm ag-flex ag-flex-col ag-gap-y-1"
          htmlFor="description"
        >
          <div className="ag-text-neutral-900 ag-font-semibold">
            Description
          </div>
          <div className="ag-text-gray-muted">
            Describe your character in a few words
          </div>
        </label>
        <textarea
          className={clsx(
            'ag-border ag-text-neutral-900 ag-border-neutral-300 ag-py-2 ag-px-3 ag-rounded-md ag-text-sm ag-outline-none ag-ring-0 focus:ag-outline-none focus:ag-ring-0 ag-bg-neutral-50',
            formik.errors.systemPrompt && formik.touched.systemPrompt
              ? 'ag-text-red-900  focus:ag-border-red-500'
              : 'placeholder:ag-text-neutral-500 focus:ag-border-primary-800'
          )}
          placeholder="For example, “An expert in digital marketing strategies.”"
          name="systemPrompt"
          id="systemPrompt"
          onBlur={formik.handleBlur}
          onChange={formik.handleChange}
          value={formik.values.systemPrompt}
        />
        <div className="ag-flex ag-items-center ag-justify-between">
          <div>
            {formik.errors.systemPrompt && formik.touched.systemPrompt && (
              <FormError>{formik.errors.systemPrompt}</FormError>
            )}
          </div>
        </div>
      </div>
      {/* <label className="ag-text-sm ag-flex ag-flex-col ag-gap-y-1">
        <div className={'ag-font-semibold ag-text-sm'}>Voice</div>
        <div className="ag-text-gray-muted">
          We recommend using the default voice
        </div>
      </label>
      <div className="ag-flex ag-flex-col ag-relative ag-gap-y-2">
        <VoiceSelectButton
          currentVoice={currentVoice || null}
          onClick={() => setOpenVoiceModal(true)}
        />
      </div> */}

      <div className="ag-flex ag-flex-col ag-gap-y-2">
        <label className="ag-text-sm ag-flex ag-flex-col ag-gap-y-1">
          <div className="ag-text-neutral-900 ag-text-sm ag-font-semibold">
            Default language
          </div>
          <div className="ag-text-gray-muted">
            This language will be used by default when the call starts.
          </div>
        </label>
        <SelectInput
          name="select-language"
          options={LANGUAGES}
          value={
            LANGUAGES.find(
              (item) => item.toLowerCase() === formik.values.defaultLanguage
            )!
          }
          onChange={(value) =>
            formik.setFieldValue('defaultLanguage', value.toLowerCase())
          }
          optionsWrapperClassName={cn(
            '!ag-bg-white !ag-border-neutral-200 ag-max-h-60'
          )}
          className={cn(
            '!ag-bg-neutral-50 !ag-border-neutral-200 !ag-text-neutral-700 !ag-px-3 !ag-py-2 ag-mb-6'
          )}
          wrapperClassName={cn(
            '!ag-bg-white !ag-text-neutral-700 !ag-border-neutral-200'
          )}
          optionsClassName={cn(
            'ag-text-sm ag-py-1 ag-text-neutral-700 ag-border-neutral-200  hover:ag-bg-neutral-200/80 dark:hover:ag-bg-[#262626]/80'
          )}
          activeClassName={cn('!ag-bg-neutral-100')}
        />
      </div>

      <div className="ag-flex ag-flex-col ag-relative ag-gap-y-2">
        <AvatarListModal
          setOpen={setOpenAvatarListModal}
          open={openAvatarListModal}
        />
      </div>

      <div className="ag-flex ag-flex-col ag-relative ag-gap-y-2">
        <VoiceModal
          open={openVoiceModal}
          setOpen={setOpenVoiceModal}
          currentVoice={currentVoice}
          chooseVoice={(voice) =>
            formik.setFieldValue('voiceId', voice?.providerId || '')
          }
        />
      </div>
    </div>
  );
};
